<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Fotoğraf Galerisi</b-card-title>
      <div>
        <b-button
          variant="primary"
          class="mr-1"
          @click="setModal('products-media',cropperSettings.fileName)"
        >
          <FeatherIcon icon="UploadIcon" />
          Fotoğraf Yükle
        </b-button>
        <b-button
          variant="success"
          class="mr-1"
          @click="triggerBulkUpload"
        >
          <FeatherIcon icon="UploadIcon" />
          Toplu Fotoğraf Yükle
        </b-button>
        <b-form-file
          ref="bulkFileInput"
          v-model="bulkFiles"
          multiple
          accept="image/*"
          class="d-none"
          @change="handleBulkFilesChange"
        />
      </div>
    </b-card-header>
    <b-card-body>
      <div
        v-if="dataItem.images"
      >
        <draggable
          v-model="images"
          tag="ul"
          class="cursor-move p-0 row match-height"
        >
          <div
            v-for="(image, index) in images"
            :key="index"
            tag="li"
            class="col-auto col-md-3"
          >
            <div
              class="border-light rounded p-1 mb-2"
              :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
            >
              <div
                class="height-auto overflow-hidden"
                :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
              >
                <b-img
                  :src="imageUrl + 'media/products-media/' + image.thumb"
                  fluid
                  class="h-auto w-100"
                />
                <b-form-input
                  v-model="image.title"
                  size="sm"
                  class="mt-1"
                  placeholder="Görsel Açıklama"
                />
              </div>
              <div class="border-top mt-1 d-flex justify-content-around">
                <b-button
                  variant="outline-success"
                  size="sm"
                  pill
                  class="btn-icon mt-1"
                  :disabled="!image.id"
                  @click="saveImage(image)"
                >
                  <FeatherIcon icon="CheckIcon" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  pill
                  class="btn-icon mt-1"
                  @click="removeImage(image,index)"
                >
                  <FeatherIcon icon="TrashIcon" />
                </b-button>
              </div>
            </div>
          </div>
        </draggable>
        <b-alert
          show
          variant="info"
        >
          <div class="alert-body text-center">
            <FeatherIcon icon="InfoIcon" /> Fotoğrafları sıralamak için sürükleyin.
          </div>
        </b-alert>
        <hr>
      </div>
    </b-card-body>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        component="products-media"
        :params="cropperSettings.type"
        :item-id="dataItem.id"
        :current-file="cropperSettings.currentFile"
        :is-bulk="cropperSettings.isBulk"
        :bulk-progress="cropperSettings.bulkProgress"
        @uploadImage="handleUploadImage"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BImg, BButton, BAlert, BFormInput, BFormFile,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import CropperImage from '@/layouts/components/common/CropperImage3.vue'

export default {
  name: 'PhotoGallery',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BImg,
    BButton,
    BFormInput,
    BFormFile,
    BAlert,
    draggable,
    CropperImage,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      images: [],
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
      bulkFiles: [],
      bulkUploadQueue: [],
      currentBulkIndex: 0,
      isBulkUploading: false,
      bulkUploadInProgress: false,
    }
  },
  computed: {
    dataItem() {
      const data = this.$store.getters['products/dataItem']
      if (data) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.images = data.images
      }
      return data
    },
  },
  watch: {
    images() {
      this.$store.dispatch('products/reOrderingImages', this.images)
    },
  },
  methods: {
    setModal(type,file) {
      const fileNamee = file?.name
      if (type === 'products-media') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          widthSize: 1024,
          folder: 'products-media',
          ratio: 1024 / 768,
          type: 'products-media',
        }
      }
    },
    closeModal() {
      if (this.cropperSettings.isBulk) {
        if (this.bulkUploadInProgress) {
          return
        }
        this.currentBulkIndex++
        if (this.currentBulkIndex < this.bulkUploadQueue.length) {
          this.$nextTick(() => {
            this.processNextBulkFile()
          })
        } else {
          this.isBulkUploading = false
          this.bulkUploadQueue = []
          this.bulkFiles = []
          this.currentBulkIndex = 0
          this.cropperSettings = {
            modalStatus: false,
            fileName: null,
            folder: null,
            ratio: null,
            type: null,
            isBulk: false,
            currentFile: null,
            bulkProgress: null,
          }
        }
      } else {
        this.cropperSettings = {
          modalStatus: false,
          fileName: null,
          folder: null,
          ratio: null,
          type: null,
          isBulk: false,
          currentFile: null,
          bulkProgress: null,
        }
      }
    },
    handleUploadImage(item) {
      if (this.cropperSettings.isBulk) {
        this.handleBulkUploadComplete(item)
      } else {
        this.setUploadImage(item)
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'products-media') {
        this.dataItem.images.push({
          id: null,
          title: null,
          filename: item.filename,
          thumb: item.thumb,
          filename_webp: item.filename_webp,
          thumb_webp: item.thumb_webp,
        })
      }
      this.cropperSettings.modalStatus = false
    },
    saveImage(data) {
      this.$store.dispatch('products/saveImage', data)
    },
    removeImage(data, index) {
      if (data.id) {
        this.$store.dispatch('products/removeImageData', data)
          .then(response => {
            if (response) {
              this.dataItem.images.splice(index, 1)
            }
          })
      } else {
        this.dataItem.images.splice(index, 1)
      }
    },
    triggerBulkUpload() {
      const fileInput = this.$refs.bulkFileInput
      if (fileInput && fileInput.$el) {
        const input = fileInput.$el.querySelector('input[type="file"]')
        if (input) {
          input.click()
        }
      }
    },
    handleBulkFilesChange(event) {
      const files = event.target.files || event.dataTransfer?.files
      if (!files || files.length === 0) {
        if (this.bulkFiles && this.bulkFiles.length > 0) {
          this.handleBulkFiles(this.bulkFiles)
        }
        return
      }
      this.handleBulkFiles(files)
    },
    handleBulkFiles(files) {
      let fileArray = []
      if (files instanceof FileList) {
        fileArray = Array.from(files)
      } else if (Array.isArray(files)) {
        fileArray = files
      } else if (files) {
        fileArray = [files]
      }
      if (fileArray.length === 0) return

      this.bulkUploadQueue = fileArray
      this.currentBulkIndex = 0
      this.isBulkUploading = true

      if (this.$refs.bulkFileInput) {
        this.$refs.bulkFileInput.$el.querySelector('input[type="file"]').value = ''
      }
      this.bulkFiles = []

      this.$nextTick(() => {
        this.processNextBulkFile()
      })
    },
    processNextBulkFile() {
      if (this.currentBulkIndex >= this.bulkUploadQueue.length) {
        this.isBulkUploading = false
        this.bulkUploadQueue = []
        this.bulkFiles = []
        this.currentBulkIndex = 0
        return
      }
      const file = this.bulkUploadQueue[this.currentBulkIndex]
      this.setBulkModal('products-media', file)
    },
    setBulkModal(type, file) {
      if (type === 'products-media') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: file.name || 'products-media-image.jpg',
          folder: 'products-media',
          ratio: 1024 / 768,
          widthSize: 1024,
          type: 'products-media',
          isBulk: true,
          currentFile: file,
          bulkProgress: {
            current: this.currentBulkIndex + 1,
            total: this.bulkUploadQueue.length,
          },
        }
      }
    },
    handleBulkUploadComplete(item) {
      if (this.cropperSettings.type === 'products-media') {
        this.dataItem.images.push({
          id: null,
          title: null,
          filename: item.filename,
          thumb: item.thumb,
          filename_webp: item.filename_webp,
          thumb_webp: item.thumb_webp,
        })
      }
      this.bulkUploadInProgress = true
      this.currentBulkIndex++
      this.cropperSettings.modalStatus = false

      this.$nextTick(() => {
        this.bulkUploadInProgress = false
        this.processNextBulkFile()
      })
    },
  },
}
</script>
